import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function UsdtOnlyNotice() {
  const { t } = useTranslation('cabinet');

  return (
    <div
      className="grid grid-cols-[auto_1fr] items-start gap-2.5 rounded-lg border border-border bg-accent/40 p-3 sm:p-3.5"
      role="note"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
      <div className="min-w-0 text-sm">
        <p className="font-medium text-foreground">{t('withdrawal.modal.usdtOnlyTitle')}</p>
        <p className="mt-0.5 text-muted-foreground">{t('withdrawal.modal.usdtOnlyBody')}</p>
      </div>
    </div>
  );
}
